import { Link } from "react-router-dom";

const VARIANTS = {
  primary: "skew-btn",
  magenta: "skew-btn skew-btn--magenta",
  lime: "skew-btn skew-btn--lime",
};

export default function SkewButton({
  to,
  href,
  onClick,
  type = "button",
  variant = "primary",
  children,
  className = "",
  ...rest
}) {
  const cls = `${VARIANTS[variant] || VARIANTS.primary} ${className}`;
  const content = <span>{children}</span>;

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls} {...rest}>
      {content}
    </button>
  );
}
